export default __webpack_public_path__ + "static/media/magic-boy-spell.1125c182.gif";